import React, { Component }          from 'react';
import { withRouter }                from 'react-router';
import { Jumbotron, Accordion, 
         Card, Container,
         Row, Col, Button,
         Tab, Form, Nav,
         Toast, Badge, Spinner }     from 'react-bootstrap';
import { Input }                     from 'reactstrap';
import hash                          from 'object-hash';
import { connect as reduxConnect }   from 'react-redux';
import PubSub                        from 'pubsub-js';
import { ClipLoader }                from 'react-spinners';
import { FaCopy }                    from 'react-icons/fa';
import { FaWindowClose }             from 'react-icons/fa';
import                                    'amazon-connect-streams'; // Used in AdminLanding
import                                    'amazon-connect-chatjs';  // Used in UserLanding
import { ConnectConstants }          from '../environment';
import FeedbackWidget                from '../../feedback/widget/FeedbackWidget';
import { connectInstancesFetchData } from '../../../../actions/connect/instances';
import { cannedResponsesGetFetchData,
         cannedResponsesAddFetchData,
         cannedResponsesDeleteFetchData,
         cannedResponsesUpdateFetchData 
        }                            from '../../../../actions/connect/cannedResponses';
import { connectSourcesFetchData }   from '../../../../actions/connect/sources';
import { attributeFromToken }        from '../../../../utils/authService';
import LogRocketInit                 from '../../../../utils/LogRocket'; 
import Sticky                        from 'react-stickynode';

var apiHost = ConnectConstants.WebApiHost;

class AdminLanding extends Component {
  constructor(props) {
    super(props);
    this.state = { 
      loading      : true,
      openRelay    : false,
      contacts     : [],
      faq          : [],
      url          : '',
      relay        : '',
      interval     : 15000,
      intervalFunc : null,
      agent        : null,
      date         : Date.now(),
      showToast    : false,
      toastMessage : '',
      loadingCan   : false
    };
    
    this.init            = this.init.bind(this);
    this.replace         = this.replace.bind(this);
    this.subscriber      = this.subscriber.bind(this);
    this.hashObject      = this.hashObject.bind(this);
    this.updateDate      = this.updateDate.bind(this);
    this.copyToClipboard = this.copyToClipboard.bind(this);
    this.handleLeavePage = this.handleLeavePage.bind(this);
  }
  
  componentDidMount() {
    LogRocketInit();
    this.token = PubSub.subscribe('connect.chat.instances', this.subscriber.bind(this));
    this.props.fetchDataInstances(apiHost);
    this.props.fetchDataCannedResponses(apiHost);
    this.props.fetchDataSources(apiHost, true);
    
    window.addEventListener('beforeunload', this.handleLeavePage);
  }
  
  componentWillUnmount(){
    PubSub.unsubscribe(this.token);
    
    window.removeEventListener('beforeunload', this.handleLeavePage);
    
    if (this.state.intervalFunc) {
      window.clearInterval(this.state.intervalFunc);
    }
    
    window.connect.core.terminate();
  }

  componentDidUpdate(prevProps) {
    // Probably not needed after the web services are fixed
     if (JSON.stringify(this.props.cannedResponsesGet) !== JSON.stringify(prevProps.cannedResponsesGet)) {
        this.setState({
          loadingCan : false
        });
    } 
  }
  
  subscriber(msg, data) {
    var that = this;
    if (msg === "connect.chat.instances" && !this.state.url) {
      this.setState({
        relay : data.RelayState,
        url   : data.CCPUrl,
        faq   : data.Faq
      }, function() {
        window.connect.core.initCCP(document.getElementById('agent-attributes'), {
          ccpUrl:        data.CCPUrl,    /*REQUIRED (*** has been replaced) */
          loginPopup:    false,          /*optional, default TRUE*/
          region:        'us-west-2',
          softphone:     {               /*optional*/
            allowFramedSoftphone: true
          }
        });
        
        window.connect.agent(function(agent) {
          console.log(JSON.stringify(agent.getConfiguration()));
          console.log('agent connected');
          that.setState({
            agent: agent
          });
        });
        
        window.connect.contact(function(contact) {

          contact.onIncoming(function(ct) {
            console.log('chat contact incoming');
          });

          contact.onRefresh(function(ct) {
            console.log('chat contact refresh');
            if (!that.state.contacts.some(c => (ct.getContactId() === c.contactId || c.hash !== hash(ct.getAttributes())))) {
              that.setState({
                contacts: that.state.contacts.concat({
                  contactId: ct.getContactId(),
                  attributes: ct.getAttributes(),
                  lastUpdated: Date.now(),
                  hash: that.hashObject(ct.getAttributes())
                })
              })
            }
          });

          contact.onAccepted(function(ct) {
            console.log('chat contact accepted');
          });

          contact.onEnded(function(ct) {
            console.log('chat contact ended');
            if (that.state.contacts.some(c => ct.getContactId() === c.contactId)) {
               that.setState({contacts: that.state.contacts.filter(function(c) { 
                  return c.contactId !== ct.getContactId() 
                })
              });
            }
          });

          contact.onConnected(function(ct) {
            console.log('chat contact connected');
            if (!that.state.contacts.some(c => (ct.getContactId() === c.contactId))) {
              that.setState({
                contacts: that.state.contacts.concat({
                  contactId: ct.getContactId(),
                  attributes: ct.getAttributes(),
                  lastUpdated: Date.now(),
                  hash: that.hashObject(ct.getAttributes())
                })
              })
            }
          });
        });
        
        var intervalFunc = window.setInterval(this.init, 500);
        this.setState({
          intervalFunc: intervalFunc
        });
      });
    }
  }
  
  hashObject(obj) {
    return hash(obj);
  }
  
  updateDate() {
    console.log('hearbeat');
    this.setState({
      date: Date.now()
    });
    
    this.props.fetchDataSources(apiHost, true);
  }
  
  copyToClipboard(attribute, value) {
    var tempInput = document.createElement("input");
    tempInput.style = "position: absolute; left: -1000px; top: -1000px";
    tempInput.value = value;
    document.body.appendChild(tempInput);
    tempInput.select();
    document.execCommand("copy");
    document.body.removeChild(tempInput);
    this.setState({showToast: true, toastMessage: "\""+value+"\" was copied to the clipboard!"});
  }
  
  handleLeavePage(e) {
    if (this.state.agent != null) {
      // TODO: Is this best? Not sure what else can be done at the moment
      /*let states = this.state.agent.getAgentStates();
      // "states" is an array of changeable states. You can filter the desired state to change by name.
      let offlineState = states.filter(state => state.name === "Offline")[0];

      // Change agent state
      this.state.agent.setState(offlineState, {
        success: function() {
          console.log("SetState succeeded");
        },
        failure: function() {
          console.log("SetState failed");
          return "Failed to set state to Offline, please try again";
        }
      });*/
    }
  }
  
  lastUpdated(obj) {
    var minutes = Math.trunc((Date.now() - obj.lastUpdated)/1000/60);
    if (minutes < 1) {
      return 'Just now';
    }
    else {
      if (minutes >= 60) {
        var hours = Math.trunc(Math.floor(minutes/60));
        if (hours > 1) {
          return hours + ' hours ago';
        }
        else {
          return hours + ' hour ago';
        }
      }
      else {
        if (minutes > 1) {
          return minutes + ' minutes ago';
        }
        else {
          return minutes + ' minute ago';
        }
      }
    }
  }
  
  computeDynamicLinks(link) {
    var inputs    = [];
    var clickable = (
      <a target='_blank' rel="noopener noreferrer" href={link.Link}>{link.Title}</a>
    );
    
    if (link.Inputs) {
      link.Inputs.forEach(input => {
        var defaultValue = input.DefaultValue;
        if (input.DefaultValue && input.DefaultValue.startsWith('[Role]')) {
          var roles = attributeFromToken('role');
          if (roles) {
            defaultValue = roles.find(element => element.startsWith(input.DefaultValue.split('[Role].')[1]));
          }
        }
        
        inputs.push(
          <Form.Group key={input.Name}>
            <Form.Label>{input.Title}</Form.Label>
            <Form.Control name={input.Name} type={input.Type} defaultValue={defaultValue} placeholder={input.Placeholder} required />
            <span className="text">
              {input.Description}
            </span>
          </Form.Group>
        );
      });
      
      if (link.Action && link.Action.hasOwnProperty('Replace')) {
        clickable = (
          <button type='submit' className="c-btn c-btn--sm">
            <span className="c-btn__text">{link.Title}</span>
          </button>
        );
      }
      
      return ( 
        <Form onSubmit={this.replace}>
          {inputs}
          <input type='hidden' value={JSON.stringify(link)} name='Replace.Json' />
          {clickable}
        </Form>
      );
    }
    
    return (
      <span>
        {clickable}
      </span>
    );
  }
  
  replace(e) {
    e.preventDefault();
    e.stopPropagation();
    var form = new FormData(e.currentTarget);
    if (e.currentTarget.checkValidity() !== false) {
      var link   = JSON.parse(form.get('Replace.Json'));
      var follow = link.Link;
      link.Action.Replace.forEach(action => {
        follow = follow.replace(action.Text, form.get(action.Name));
      });
      
      window.open(follow);
    }
  }
  
  init() {
    if (window.connect.core.initialized) {
      window.clearInterval(this.state.intervalFunc);
      this.setState({
        loading: false
      }, function() {
        var intervalFunc = window.setInterval(this.updateDate, this.state.interval);
        this.setState({
          intervalFunc: intervalFunc
        });
        
        document.getElementById('agent-attributes').style.display = 'block';
      });
    }
  }

  render() {
    return (
      <Container>
        <Sticky>
        <div
          style={{
            position: 'absolute',
            right: 200,
          }}
         >
         <Toast show={this.state.showToast} autohide={true} delay={3000} 
            onClose={() => {this.setState({showToast: false})}}
          >
            <Toast.Header>
              <strong>Copied to clipboard!</strong>
            </Toast.Header>
            <Toast.Body>{this.state.toastMessage}</Toast.Body>
          </Toast> 
          </div>
        </Sticky>
        <Row>
          <Col xs={12}>
            <Tab.Container defaultActiveKey="chat">
              <Nav variant="pills">
                <Nav.Item>
                  <Nav.Link className="tabbed__nav-item swiper-slide swiper-slide-active" eventKey="chat">Chat</Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link className="tabbed__nav-item swiper-slide swiper-slide-active" eventKey="faq">Frequently Asked Questions</Nav.Link>
                </Nav.Item>
              </Nav>
              <Tab.Content>
                <Tab.Pane eventKey="chat">
                  <Container style={{ marginTop: '10px' }}>
                    <Row>
                      <Col xs={8}>
                        { this.state.loading ?
                            !this.state.relay ?
                              <div style={{ marginRight: 'auto', marginLeft: 'auto', width: '5em' }}>
                                <ClipLoader
                                  color={'#072659'} 
                                  loading={this.props.sourcesIsLoading} 
                                />
                              </div>
                              :
                              <Jumbotron>
                                <h1>Hello, { attributeFromToken('given_name') }!</h1>
                                <p>
                                { this.props.connectInstances.Jumbotron && this.props.connectInstances.Jumbotron.Header }
                                </p>
                                <p>
                                  <a rel='noopener noreferrer' target='_blank' href={this.state.relay} className="c-btn c-btn--sm" style={{padding: '4px 42px 1px 14px', marginBottom: '10px'}}>
                                    <span className="c-btn__text">Open AWS Connect</span>
                                  </a>
                                </p>
                              </Jumbotron>
                          :
                          <span></span>
                        }
                        <FeedbackWidget render={true} value={true} />
                        <div style={{ display: 'none' }} id='agent-attributes'>
                              
                        </div>
                      </Col>
                      <Col xs={4}>
                        { this.props.connectSources && this.props.connectSources.AgentData ?
                          <Card key={this.state.date}>
                            <Card.Header as="h5" style={{ marginTop: 0 }}>
                              { this.props.connectSources.AgentData.Status ?
                                <span>Your Status (Available) &nbsp;</span>
                                :
                                <span>Your Status (Unavailable) &nbsp;</span>
                              }
                            </Card.Header>
                            <Card.Body>
                              <label className="switch">
                                <input type="checkbox" readOnly checked={this.props.connectSources.AgentData.Status} />
                                <span className="slider round"></span>
                              </label>
                              <div>
                                { this.props.connectSources.Sources.map((element, index) => (
                                  <div key={this.state.date + index}>
                                    <h3 style={{ color: '#0033A0', display: 'inline' }}>{element.Title}</h3>
                                    &nbsp;
                                    {
                                      element.Online ? 
                                      <Badge title='Online' variant="success">Online</Badge>
                                      :
                                      <Badge title='Offline' variant="danger">Offline</Badge>
                                    }
                                  </div>
                                ))}
                              </div>
                            </Card.Body>
                          </Card>
                          :
                          <span></span>
                        }
                        <a rel='noopener noreferrer' target='_blank' href={this.state.relay} className="c-btn c-btn--sm" style={{ padding: '4px 42px 1px 14px', marginBottom: '10px', width: '100%' }}>
                          <span className="c-btn__text">Open AWS Connect</span>
                        </a>
                        <Tab.Container defaultActiveKey="connected">
                          <Nav variant="pills">
                            <Nav.Item>
                              <Nav.Link className="tabbed__nav-item swiper-slide swiper-slide-active" eventKey="connected">Connected</Nav.Link>
                            </Nav.Item>
                            <Nav.Item>
                              <Nav.Link className="tabbed__nav-item swiper-slide swiper-slide-active" eventKey="responses">Responses</Nav.Link>
                            </Nav.Item>
                          </Nav>
                          <Tab.Content>
                            <Tab.Pane eventKey="connected">
                              <Container style={{ marginTop: '10px', width: '100%' }}>
                              { this.state.contacts.map((contact, index) => (
                                <Accordion key={index}>
                                  <Card>
                                    <Card.Header>
                                      <Accordion.Toggle as={Button} variant='link' eventKey={index}>
                                        { contact.attributes['Username'] ? contact.attributes['Username'].value : '' }
                                      </Accordion.Toggle>
                                    </Card.Header>
                                    <Accordion.Collapse eventKey={index}>
                                      <div>
                                        <Card.Body>
                                          <Card.Text>
                                            { 
                                              Object.keys(contact.attributes).map((k) => (
                                                <span key={k} style={{ lineHeight: 2, fontSize: '14px' }}>
                                                  <b>{k}</b>:&nbsp;
                                                  { contact.attributes[k].value ?
                                                    <span>
                                                      {contact.attributes[k].value}
                                                      <a title='Copy to clipboard' href='/#/connect/admin' style={{ marginLeft: '5px' }} onClick={() => this.copyToClipboard(k, contact.attributes[k].value)}>
                                                        <FaCopy />
                                                      </a>
                                                    </span>
                                                    :
                                                    <span>n/a</span>
                                                  }
                                                  <br />
                                                </span>
                                              ))
                                            }
                                          </Card.Text>
                                        </Card.Body>
                                        <Card.Footer>
                                          <small className="text">Last updated {this.lastUpdated(contact)}</small>
                                          <span style={{ display: 'none' }} >{ this.state.date }</span>
                                        </Card.Footer>
                                      </div>
                                    </Accordion.Collapse>
                                  </Card>
                                </Accordion>
                              ))
                             }
                             </Container>
                           </Tab.Pane>
                           <Tab.Pane eventKey="responses">
                           <Spinner animation="grow" hidden={!this.state.loadingCan}/>
                              <div style={{ marginTop: '10px' }}>
                                <div className='input-group'>
                                  <Input className="canned-responses-add-input width100" id="canned-responses-add" type="text" placeholder="Save A Response" />
                                  {/* Uncomment these to allow public/private responses*/}
                                  {/* <input class="canned-responses-add-private"  */}
                                    {/* type="checkbox" name="canned-responses-private-add" id="canned-responses-isPrivate-add" /> */}
                                  {/* <label>Set to Public?</label> */}
                                  <span className='input-group-btn'>
                                    <button id="canned-responses-add-button" className="c-btn c-btn--sm" style={{padding: '4px 42px 1px 14px'}}                              
                                      // Commenting to set default private
                                      // !document.getElementsByClassName("canned-responses-add-private")[0].checked+'}'));
                                      onClick={() => {this.props.fetchDataAddCannedResponses(apiHost, 
                                        JSON.parse('{ "Responses": "'+
                                        document.getElementsByClassName("canned-responses-add-input")[0].value+'", "IsPrivate": '+
                                        false+'}'));
                                        this.setState({loadingCan : true});
                                      }}>
                                      <span className="c-btn__text">Add</span>
                                    </button>
                                  </span>
                                </div>
                              </div>
                              { this.props.cannedResponsesGet.map((responses, index) => (
                                <Card key={index} style={{ marginBottom: 0 }}>
                                  <Card.Body> 
                                    <div style={{ marginBottom: '10px' }} >                                  
                                      <a href="/#/connect/admin" title="Copy to Clipboard" onClick={() => {this.copyToClipboard(null, responses.Responses);
                                      }}>
                                        <h3 style={{ color: '#0033A0', display: 'inline' }}>{responses.Responses}</h3>
                                      </a>
                                    </div>
                                      {/* Uncomment these to allow public/private responses*/}
                                    {/* <Card.Subtitle> {responses?.EmployeeId ? "Private Response" : "Public Response"} </Card.Subtitle> */}
                                  
                                    <div>
                                      <a href="/#/connect/admin" title="Delete Response" style={{ marginLeft: '20px', float: 'right' }}
                                        onClick={() => {
                                          this.props.fetchDataDeleteCannedResponses(apiHost, JSON.parse('{"Id": "'+responses.Id+'"}'));
                                          this.setState({loadingCan : true});
                                      }}>
                                        <FaWindowClose size={24} color={ 'red' } />
                                      </a>
                                    </div>
                                    <div style={{ marginTop: '40px' }} >
                                      <div className='input-group'>
                                        <Input className="canned-responses-update-input width100" type="text" placeholder="Update Response" />
                                        {/* Uncomment these to allow public/private responses*/}
                                        {/* <input class="canned-responses-edit-private"  */} 
                                          {/* type="checkbox" name="canned-responses-private-radio" id="canned-responses-isPrivate-radio" /> */}
                                        {/* <label>Set to Public?</label> */}
                                        <span className='input-group-btn'>
                                          <button id="canned-responses-update-button" className="c-btn c-btn--sm" style={{padding: '4px 42px 1px 14px'}}                                  
                                            onClick={() => {
                                              // If update box is left empty then user most likely wants to just set it to public
                                              // so we will just attach the old response value
                                              var check = document.getElementsByClassName("canned-responses-update-input")[index].value ?
                                              document.getElementsByClassName("canned-responses-update-input")[index].value : responses.Responses;
                                              // Once a response is public, it cannot be made private again because other users will lose that response
                                              // var isPrivate = responses?.EmployeeId ? !document.getElementsByClassName("canned-responses-edit-private")[index].checked : false;
                                              var isPrivate = false; // uncomment above to allow public/private responses
                                              // Check to see if edit input change, don't load if it didn't
                                              // Check if empty first, then check if equal
                                              var spinnerCheck = document.getElementsByClassName("canned-responses-update-input")[index].value ? 
                                                responses.Responses.toString() === document.getElementsByClassName("canned-responses-update-input")[index].value.toString() ? 
                                                  false : true : false; 
                                              this.props.fetchDataUpdateCannedResponses(apiHost, 
                                              JSON.parse('{"Id": "'+responses.Id+'", "Responses": "'+
                                              check+'", "IsPrivate": '+isPrivate+'}')); 
                                              this.setState({loadingCan : spinnerCheck});
                                            }}>
                                            <span className="c-btn__text">Edit</span>
                                          </button>
                                        </span>
                                      </div>
                                    </div>
                                  </Card.Body>
                                </Card>
                                ))
                              }
                            </Tab.Pane>
                          </Tab.Content>
                        </Tab.Container>
                      </Col> 
                    </Row>
                  </Container>
                </Tab.Pane>
                <Tab.Pane eventKey="faq">
                  <Container style={{ marginTop: '10px' }}>
                    <Row>
                      { this.state.faq.map((faq, index) => (
                          <Accordion key={index} style={{ width: '100%' }}>
                            <Card>
                              <Card.Header>
                                <Accordion.Toggle as={Button} variant='link' eventKey={index}>
                                  { faq.Question }
                                </Accordion.Toggle>
                              </Card.Header>
                              <Accordion.Collapse eventKey={index}>
                                <div>
                                  <Card.Body>
                                    <span>{ faq.Answer }</span>
                                    <br />
                                    <br />
                                    { faq.Pre ? 
                                      <pre> { faq.Pre } </pre>
                                      :
                                      <span></span>
                                    }
                                    <span>
                                      { faq.Links && faq.Links.map((link, index) => (
                                          <span key={index}>
                                            { this.computeDynamicLinks(link) }
                                            <br />
                                          </span>
                                        ))
                                      }
                                    </span>
                                  </Card.Body>
                                </div>
                              </Accordion.Collapse>
                            </Card>
                          </Accordion>
                        ))              
                      }
                    </Row>
                  </Container>
                </Tab.Pane>
              </Tab.Content>
            </Tab.Container>
          </Col> 
        </Row>
      </Container>
    );
  }
}

const mapStateToProps = state => {
  return {
    connectInstances: state.connect.connectInstances.connectInstances,
    instancesHasErrored: state.connect.connectInstances.connectInstancesHasErrored,
    instancesIsLoading: state.connect.connectInstances.connectInstancesIsLoading,
    cannedResponsesGet: state.connect.cannedResponses.cannedResponsesGet,
    cannedResponsesGetHasErrored: state.connect.cannedResponses.cannedResponsesGetHasErrored,
    cannedResponsesGetIsLoading: state.connect.cannedResponses.cannedResponsesGetIsLoading,
    cannedResponsesAdd: state.connect.cannedResponses.cannedResponsesAdd,
    cannedResponsesAddHasErrored: state.connect.cannedResponses.cannedResponsesAddHasErrored,
    cannedResponsesAddIsLoading: state.connect.cannedResponses.cannedResponsesAddIsLoading,
    cannedResponsesUpdate: state.connect.cannedResponses.cannedResponsesUpdate,
    cannedResponsesUpdateHasErrored: state.connect.cannedResponses.cannedResponsesUpdateHasErrored,
    cannedResponsesUpdateIsLoading: state.connect.cannedResponses.cannedResponsesUpdateIsLoading,
    cannedResponsesDelete: state.connect.cannedResponses.cannedResponsesDelete,
    cannedResponsesDeleteHasErrored: state.connect.cannedResponses.cannedResponsesDeleteHasErrored,
    cannedResponsesDeleteIsLoading: state.connect.cannedResponses.cannedResponsesDeleteIsLoading,
    connectSources: state.connect.connectSources.connectSources,
    sourcesHasErrored: state.connect.connectSources.connectSourcesHasErrored,
    sourcesIsLoading: state.connect.connectSources.connectSourcesIsLoading
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchDataInstances: (host) => dispatch(connectInstancesFetchData(host)),
    fetchDataCannedResponses: (host) => dispatch(cannedResponsesGetFetchData(host)),
    fetchDataAddCannedResponses: (host, body) => dispatch(cannedResponsesAddFetchData(host, body)),
    fetchDataDeleteCannedResponses: (host, body) => dispatch(cannedResponsesDeleteFetchData(host, body)),
    fetchDataUpdateCannedResponses: (host, body) => dispatch(cannedResponsesUpdateFetchData(host, body)),
    fetchDataSources:   (host, me) => dispatch(connectSourcesFetchData(host, me))
  };
};

export default withRouter(reduxConnect(mapStateToProps, mapDispatchToProps)(AdminLanding));
